
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Photo, { isPhoto } from '@/model/Photo';
import Photos from '@/store/modules/Photos';
import { getModule } from 'vuex-module-decorators';
import { polishPlurals } from 'polish-plurals';
import ConfirmDelete from './session/ConfirmDelete.vue';
import ConfirmationModel from './ConfirmationModel';
import api from '@/service/api';
import Placeholder, { isPlaceholder } from '@/model/Placeholder';
import UploadModule from '@/store/modules/Upload';
import store from '@/store';
import Sessions from '@/store/modules/Sessions';

const photos = getModule(Photos, store);
const upload = getModule(UploadModule, store);
const sessions = getModule(Sessions, store);

@Component({
    components: {
        ConfirmDelete,
    },
})
export default class GroupOperations extends Vue {
    public confirmationModel: ConfirmationModel = new ConfirmationModel();
    @Prop({
        type: Array,
        default: () => [],
    })
    private selectedPhotos!: (Photo|Placeholder)[];
    private polishPlurals = polishPlurals;
    private recommendationInProgress = false;

    get selectedPhotoIds() {
        return [...new Set(this.selectedPhotos.filter(isPhoto).map(({ id }) => id).filter((id) => !!photos.remotePhotos[id]))];
    }

    get priceListId() {
        return sessions.sessions[this.$route.params.id]?.pricelistId;
    }

    public openPhotoSaleOptions() {
        if (this.priceListId && this.selectedPhotoIds.length) groupOperationBus.$emit('openPhotoSaleOptions', this.selectedPhotoIds);
    }

    get allRecommended() {
        return Object.entries({ ...photos.remotePhotos })
            .filter(([ photoId ]) => this.selectedPhotos.filter(isPhoto).find(({ id }) => id === photoId))
            .map(([ _, photo ]) => photo)
            .map(({ recommended }) => recommended)
            .reduce((p, c) => p && c, true);
    }

    public async deletePhotos() {
        if (this.selectedPhotos.filter(isPhoto).some(({ orderedBy }) => (orderedBy || []).length > 0)) {
            (this as any).$vToastify.error({
                title: 'Nie można usunąć.',
                body: 'Sesja ma kupione zdjęcia.',
            });
            return;
        }

        if (await this.confirmationModel.confirm('Czy usunąć te zdjęcia?')) {
            if (!await photos.deletePhotos(this.selectedPhotos.filter(isPhoto).map(({ id }) => id))) return;
            groupOperationBus.$emit('deletePhotos', this.selectedPhotos);
            this.selectedPhotos.filter(isPlaceholder).forEach(({ file }) => upload.cancelUpload({
                file
            }));
        }
    }

    public recommend() {
        this.recommendationInProgress = true;
        photos.recommendMultiple(
            this.selectedPhotos
                .filter(isPhoto)
                .map(({ id }) => id)
        );
        setTimeout(() => { this.recommendationInProgress = false; }, 2000);
    }

    public unrecommend() {
        this.recommendationInProgress = true;
        photos.unrecommendMultiple(
            this.selectedPhotos
                .filter(isPhoto)
                .map(({ id }) => id)
        );
        setTimeout(() => { this.recommendationInProgress = false; }, 2000);
    }
}

const groupOperationBus = new Vue();

export { groupOperationBus };
